const Promise = window.__Promise ?? window.Promise; // monkeypatched Promise in sling-web takes precedence

const easings = {
  linear: (t) => t,
  cubicIn: (t) => t ** 3,
  cubicOut: (t) => t ** (1 / 3),
  quartIn: (t) => t ** 4,
  quartOut: (t) => t ** 0.25,
};

export async function* anim(duration = 500, { easing = 'linear', skipInitial = false } = {}) {
  /**
   * This generator yields numbers from range [0, 1] linearly within the range of <duration> ms
   */

  if (__TEST__) {
    yield 1;
    return;
  }

  const start = Date.now();
  const stop = start + duration;
  const step = 1 / duration;

  const waitStep = () => new Promise((resolve) => requestAnimationFrame(() => resolve(Date.now())));

  const frames = duration / 16;
  const k = skipInitial ? 1 / frames : 0;

  for (let cur; (cur = await waitStep()) <= stop; ) {
    const t = step * (cur - start);
    yield easings[easing]((t + k) / (k + 1));
  }
}

export class Stream2Async {
  constructor() {
    this.resolver = null;
    this.alive = false;
    this.queue = [];

    // hardbind
    this.collect = this.collect.bind(this);
    this.produce = this.produce.bind(this);
  }
  collect(event) {
    if (!this.alive) {
      return;
    }

    this.queue.push(event);
    this.resolver?.();
    this.resolver = null;
  }
  async *produce(stop = new Promise((_) => _)) {
    this.alive = true;
    stop.then(() => (this.alive = false));

    while (this.alive) {
      while (this.queue.length) {
        yield this.queue.shift();
      }

      await new Promise((r) => (this.resolver = r));
    }
  }
}

export async function consume(iterator) {
  // eslint-disable-next-line no-unused-vars
  for await (const i of iterator) {
    /**
     * Empty.
     * The purpose is to constantly iterate over async <iterator>
     */
  }
}

export function shareIterator(iterable) {
  /**
   * We need it to use same iterator in a few for-await-of statements.
   */
  const iterator = iterable[Symbol.asyncIterator]();
  return {
    next() {
      return iterator.next();
    },
    [Symbol.asyncIterator]() {
      return this; // same reference every time
    },
  };
}
